import { render, staticRenderFns } from "./TenantSelection.vue?vue&type=template&id=2dbd4e3e"
import script from "./TenantSelection.vue?vue&type=script&lang=js"
export * from "./TenantSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports